import React, { useContext } from "react";
import { EditorContext } from "../containers/editor/EditorLayout";

const useTextAnimations = () => {
  let { metadata } = useContext(EditorContext);

  const animateText = (config, setIsAnimating) => {
    const {
      animationName,
      charClass,
      duration = 0.8,
      ease = "ease-out",
      maxTotalTime = 1.0,
      beforeWrap,
      afterRestore,
    } = config;

    metadata.activeWidgetId.forEach(id => {
      const el = document.querySelector(`#${id} .primary-text-widget`);
      if (!el) return;

      const originalHTML = el.innerHTML;
      let animatedCount = 0;

      const context = beforeWrap?.(el) || el;

      // const wrapTextNodes = node => {
      //   [...node.childNodes].forEach(child => {
      //     if (child.nodeType === 3 && child.textContent.trim().length > 0) {
      //       const fragment = document.createDocumentFragment();

      //       [...child.textContent].forEach(char => {
      //         if (char === "\n") return;

      //         const span = document.createElement("span");
      //         span.className = charClass;
      //         span.innerHTML = char === " " ? "&nbsp;" : char;

      //         fragment.appendChild(span);
      //         animatedCount++;
      //       });

      //       child.replaceWith(fragment);
      //     } else if (child.nodeType === 1) {
      //       wrapTextNodes(child);
      //     }
      //   });
      // };

      const wrapTextNodes = node => {
        [...node.childNodes].forEach(child => {
          if (child.nodeType === 3 && child.textContent.trim().length > 0) {
            const fragment = document.createDocumentFragment();

            const words = child.textContent.split(" ");

            words.forEach((word, wordIndex) => {
              const wordSpan = document.createElement("span");
              wordSpan.style.display = "inline-block"; // 🔥 IMPORTANT
              wordSpan.style.whiteSpace = "nowrap"; // 🔥 PREVENT BREAK

              [...word].forEach(char => {
                const charSpan = document.createElement("span");
                charSpan.className = charClass;
                charSpan.innerHTML = char === " " ? "&nbsp;" : char;
                wordSpan.appendChild(charSpan);
                animatedCount++;
              });

              fragment.appendChild(wordSpan);

              // add space after word (except last)
              if (wordIndex !== words.length - 1) {
                fragment.appendChild(document.createTextNode(" "));
              }
            });

            child.replaceWith(fragment);
          } else if (child.nodeType === 1) {
            wrapTextNodes(child);
          }
        });
      };

      wrapTextNodes(context);

      const charCount = Math.max(animatedCount, 1);

      // 🔥 HARD CAP DURATION
      const effectiveDuration = Math.min(duration, maxTotalTime);

      let perCharDelay = 0;
      if (charCount > 1) {
        perCharDelay = (maxTotalTime - effectiveDuration) / (charCount - 1);
        perCharDelay = Math.max(perCharDelay, 0);
      }

      let index = 0;
      context.querySelectorAll(`.${charClass}`).forEach(span => {
        span.style.animation = `
        ${animationName} ${effectiveDuration}s ${index * perCharDelay}s both ${ease}
      `;
        index++;
      });

      const totalTime = (charCount - 1) * perCharDelay + effectiveDuration;

      setTimeout(() => {
        el.innerHTML = originalHTML;
        setIsAnimating(false);
        afterRestore?.(el);
      }, totalTime * 1000);
    });
  };

  return {
    animateText,
  };
};

export default useTextAnimations;
